import React from 'react';
import { Paper, Grid, Typography, Box } from '@material-ui/core';
import useStyles from './sampleDevelopmentWl.style';
import { TextFieldFastField } from '../../../components';

interface SampleDevelopmentWlAlfrescoLinkProps {}

const SampleDevelopmentWlAlfrescoLink: React.FC<
  SampleDevelopmentWlAlfrescoLinkProps
> = () => {
  const classes = useStyles();

  return (
    <Box m={1}>
      <Paper variant="outlined">
        <Box m={1}>
          <Grid container spacing={1} direction="row" justifyContent="flex-start">
            <Grid sm={12} item>
              <Typography className={classes.title}>Alfresco Link</Typography>
            </Grid>
            <Grid sm={12} item>
              <TextFieldFastField
                name="alfrescoLink"
                label="Alfresco Link"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default SampleDevelopmentWlAlfrescoLink;
